import { render, staticRenderFns } from "./NewsDataList.vue?vue&type=template&id=327c52ce&"
import script from "./NewsDataList.vue?vue&type=script&lang=js&"
export * from "./NewsDataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports